import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {StudiewijzerlinkjesNewFacade} from '../../state/studiewijzerlinkjes/studiewijzerlinkjes.facade';

@Component({
  selector: 'app-studiewijzerlinkjes-new',
  templateUrl: './studiewijzerlinkjes-new.component.html',
  styleUrls: ['./studiewijzerlinkjes-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudiewijzerlinkjesNewComponent implements OnInit {

  constructor(store: StudiewijzerlinkjesNewFacade) { }

  ngOnInit(): void {
  }

}
